import axios from "axios";
import { endpoint } from "../utils/API";

const axiosExternalInstance = axios.create({
  baseURL: endpoint,
  headers: {
    "Content-Type": "application/json",
  },
});

export default axiosExternalInstance;
